import { useCallback } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { MissionsWithIntegerProgress } from '../../../stores/daily-missions/types';
import { useStores } from '../../../stores/useStores';
import classes from '../DailyMissions.module.scss';
import { getStaticMessage } from '../utils';

import { DailyMissionTimer } from './DailyMissionTimer';
import { GiftTooltip } from './GiftTooltip';
import { ProgressBar } from './ProgressBar/ProgressBar';

export const DailyMissionsProgressBar = observer(() => {
  const { dailyMissionsStore, coinTypeStore } = useStores();
  const { t } = useTranslation();

  const { currentDailyMission } = dailyMissionsStore;

  if (!currentDailyMission || !['ACTIVE', 'COMPLETED'].includes(currentDailyMission.status)) {
    return null;
  }

  // Progress bar interval useEffect dependency
  const onAnimationEndHandler = useCallback(() => {
    if (currentDailyMission.status === 'COMPLETED') {
      dailyMissionsStore.setDialogVisible(true);
      dailyMissionsStore.setEnableGiftAnimation(false);
    }
  }, [currentDailyMission.status, dailyMissionsStore]);

  const onClickHandler = () => {
    dailyMissionsStore.sendAnalyticsEvent({
      event_action: 'impression',
      triggered_by: 'click',
      click_location: 'progress_bar',
    });
    dailyMissionsStore.setDialogVisible(true);
  };

  const {
    progress,
    goal,
    packageData: { scCoin, gcCoin, bundleItems },
  } = currentDailyMission;

  return (
    <div className={classes.dailyMissionProgressBar}>
      <ProgressBar
        coinType={coinTypeStore.coinType}
        current={progress}
        disableAnimation={
          dailyMissionsStore.currentDailyMission?.status === 'COMPLETED' && !dailyMissionsStore.enableGiftAnimation
        }
        gameId={currentDailyMission.gameId}
        gameImageUrl={currentDailyMission.gameImageUrl}
        giftTooltip={<GiftTooltip bundleItems={bundleItems} gcCoin={gcCoin} scCoin={scCoin} />}
        integerProgress={MissionsWithIntegerProgress.includes(currentDailyMission.missionType)}
        max={goal}
        missionId={currentDailyMission.id}
        missionType={currentDailyMission.missionType}
        staticMessage={getStaticMessage(currentDailyMission, t)}
        onAnimationEnd={onAnimationEndHandler}
        onClick={onClickHandler}
        onGameClick={() => {
          dailyMissionsStore.sendAnalyticsEvent({
            event_action: 'click',
            click_location: 'game',
          });
        }}
        onGiftClick={() => {
          dailyMissionsStore.sendAnalyticsEvent({
            event_action: 'click',
            click_location: 'gift',
            action_result: 'tooltip_shown',
          });
        }}
      />
      {currentDailyMission.status === 'ACTIVE' && <DailyMissionTimer dataTestId="dailyMission-progressBar-timer" />}
    </div>
  );
});
